import React from 'react';

const Footer = () => (
    <div className="Footer">
        <div className="Footer__content">
            <p>Made by Stevan Todorovic</p>
            <div className="Footer__icons-rights">Icons from welcome page made by&nbsp;
                <a href="https://www.freepik.com/" title="Freepik" target="_blank"  rel="noopener noreferrer">Freepik</a> from&nbsp;
                <a href="https://www.flaticon.com/" title="Flaticon" target="_blank"  rel="noopener noreferrer">www.flaticon.com</a> is licensed by&nbsp;
                <a href="http://creativecommons.org/licenses/by/3.0/" title="Creative Commons BY 3.0" target="_blank"  rel="noopener noreferrer">CC 3.0 BY
                </a>
            </div>
        </div>
    </div>
);

export default Footer;